
(function(template){
  define('vue!optionalClassProgram/components/classComponents/optionalComponents/optionalClassComponent',[
    "Vue",
    "helpers",
    "vuex",
    "moment",
    "vue!./groupedClassesComponent",

  ], function (
    Vue,
    helpers,
    vuex,
    moment,
    groupedClassesComponent
  ) {
    return {
      template: template,
      name: "optionalClasses",
      props: ['customerID'],
      computed: _.extend(
        vuex.mapState(['users','currentlyBookingClassProgram']), {
          optionalClasses: function(){
            return this.groupClasses("Y",this.customerID)
          },
      }),
      components: {
          'groupedClassesComponent':groupedClassesComponent
      },
    }
  })
})('<div> <div class="optionalClassComponent-addon-text" v-if="!_.isEmpty(optionalClasses)"> <strong>{{localStrings.ageRestriction.optionalClass.addon}}</strong> <span >{{localStrings.ageRestriction.optionalClass.optionalClassMessage}}</span> <p class="inner-service-bookMode-warning" v-if="currentlyBookingClassProgram.BookMode == \'F\'">{{localStrings.ageRestriction.optionalClass.groupedBookingWarning}}</p> </div> <div class="accordion" id="accordion2"> <div class="accordion-group" v-for="(value, propertyName, oIndex) in optionalClasses" :key="oIndex"> <groupedClassesComponent v-bind:customerID="customerID" v-bind:propertyName="propertyName" v-bind:oIndex="oIndex" v-bind:optionalClasses="optionalClasses" v-bind:classes="value" ></groupedClassesComponent> </div> </div> </div>');
